export default [
  // Centers
  {
    path: "/0f6065d1dbff38566491fe1f",
    children: [
      {
        path: "0f9b972a69916132fdf86fed",
        name: "bece26.centers",
        meta: {
          title: "BECE 2026 centers",
          authRequired: true,
          acc: ["y48633"],
        },
        component: () => import("@/views/bece/tws/center_management/index.vue"),
      },
      // view center
      {
        path: "feee9bd74e3103fd28a83d9067557115a5987001e094e817/:cn?",
        name: "bece26.center.view",
        meta: {
          title: "View BECE 2026 center",
          authRequired: true,
          acc: ["y52481"],
        },
        component: () => import("@/views/bece/tws/center_management/view.vue"),
      },

      // assign center
       {
        path: "w2cd61b95f477fdf0568bf3f/:cn?",
        name: "bece26.center.create",
        meta: {
          title: "Create BECE 2026 center",
          authRequired: true,
          acc: ["y99931"],
        },
        component: () => import("@/views/bece/tws/center_management/create.vue"),
      },
      //   {
      //     path: "hgnerugervbhoiuvervgye",
      //     name: "newCenters",
      //     meta: {
      //       title: "2025 BECE NEW CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/newCenters.vue"),
      //   },
      //   {
      //     path: "center_requests",
      //     name: "newCenterRequest",
      //     meta: {
      //       title: "2025 BECE NEW CENTERS Requests",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/requests.vue"),
      //   },
      //   {
      //     path: "center_request/:cn?",
      //     name: "CenterRequestv",
      //     meta: {
      //       title: "2025 BECE Requests Details",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/request.vue"),
      //   },
      //   {
      //     path: ":cn/edit_center",
      //     name: "editCenter",
      //     meta: {
      //       title: "EDIT CENTERS",
      //       authRequired: true,
      //       acc: ["y99931"],
      //     },
      //     component: () =>
      //       import("../views/bece/twf/center_management/edit-center.vue"),
      //   },
    ],
  },
];
